module.exports = __webpack_public_path__ + "img/estrutura.a0d5aea8.jpg";